import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from "react";
import iconSizes from "../iconSizes";
import { deprecatedPropValueMessage } from "../../../utils/deprecationUtils";
var isDeprecatedIconSize = function(iconSize) {
    if (typeof iconSize === 'undefined') {
        return false;
    }
    return iconSize === 'xl';
};
var CanvasRulerIcon = function(param) {
    var _size = param.size, size = _size === void 0 ? 's' : _size, _color = param.color, color = _color === void 0 ? 'currentColor' : _color, title = param.title;
    if (isDeprecatedIconSize(size)) {
        deprecatedPropValueMessage({
            componentName: 'Icon',
            propName: 'size',
            propValue: 'xl',
            date: 'Q3 2022'
        });
    }
    var ref;
    return _jsxs("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: '0 0 32 32',
        css: {
            width: iconSizes[size],
            height: iconSizes[size],
            fill: color
        },
        role: "img",
        "aria-hidden": (ref = !title) !== null && ref !== void 0 ? ref : false,
        children: [
            title && _jsx("title", {
                children: title
            }),
            _jsx("g", {
                children: _jsx("svg", {
                    viewBox: "0 0 24 24",
                    children: _jsx("path", {
                        d: "M21 1a2 2 0 011.995 1.85L23 3v3a2 2 0 01-1.85 1.995L21 8 8 7.999V21a2 2 0 01-1.85 1.995L6 23H3a2 2 0 01-1.995-1.85L1 21V3a2 2 0 011.85-1.995L3 1h18zM6 7.999L3 8v13h3v-1h-.5a1 1 0 01-.117-1.993L5.5 18H6v-2H4.5a1 1 0 01-.117-1.993L4.5 14H6v-2h-.5a1 1 0 01-.117-1.993L5.5 10H6V7.999zM6 3H3v3l3-.001V3zm2 2.999L10 6v-.5a1 1 0 011.993-.117L12 5.5V6h2V4.5a1 1 0 011.993-.117L16 4.5V6h2v-.5a1 1 0 011.993-.117L20 5.5V6h1V3L8 2.999v3z",
                        fillRule: "evenodd"
                    })
                })
            })
        ]
    });
};
CanvasRulerIcon.isCarinaIcon = true;
export default CanvasRulerIcon;
